export default __webpack_public_path__ + "static/media/CBD_logo_FR_white@2x.3d779d5a.png";